import { Facebook, Instagram, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NewsletterSignup } from '@/features/newsletter/NewsletterSignup';
import { Container } from './Container';
import { NAV_LINKS } from './navConfig';

const ORG_EMAIL = import.meta.env.VITE_ORG_EMAIL ?? 'hello@careforhim.org';

export function Footer() {
  return (
    <footer className="mt-20 border-t border-line bg-surface-2/60">
      <Container className="grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src="/logo.jpeg" alt="Care For Him" className="h-12 w-auto" />
          <p className="mt-4 max-w-sm text-sm text-muted">
            A men's mental health initiative — offering support, resources and community so no man
            faces his struggles alone.
          </p>
          <div className="mt-4 flex gap-3">
            <a href="#" aria-label="Facebook" className="text-purple-500 hover:text-purple-600">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" aria-label="Instagram" className="text-purple-500 hover:text-purple-600">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="#" aria-label="Twitter" className="text-purple-500 hover:text-purple-600">
              <Twitter className="h-5 w-5" />
            </a>
          </div>
          <p className="mt-5 text-xs text-muted">
            Founded by <span className="font-semibold text-ink">Blessings Choongo</span>
            <span className="px-1.5">·</span>
            Co-founded by <span className="font-semibold text-ink">Mathews Tembo (BICT)</span>
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-ink">Explore</h4>
          <ul className="mt-3 space-y-2 text-sm">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-muted hover:text-teal-600">
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/get-help" className="font-medium text-pink-600 hover:text-pink-700">
                Get Help
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-ink">Stay updated</h4>
          <p className="mt-3 text-sm text-muted">Get news, events and resources in your inbox.</p>
          <div className="mt-3">
            <NewsletterSignup />
          </div>
          <a href={`mailto:${ORG_EMAIL}`} className="mt-4 block text-sm text-teal-600 hover:underline">
            {ORG_EMAIL}
          </a>
        </div>
      </Container>

      <div className="border-t border-line py-5">
        <Container className="flex flex-col items-center justify-between gap-2 text-xs text-muted sm:flex-row">
          <p>© {new Date().getFullYear()} Care For Him. All rights reserved.</p>
          <p>Made with care for men's mental health.</p>
        </Container>
      </div>
    </footer>
  );
}
